import automationAnywhereLogo from "../images/company/automation_anywhere_logo.jpeg";
import capsitechLogo from "../images/company/capsitech_logo.jpeg";
import unblueLogo from "../images/company/unblue_consultation_logo.jpeg";
import dhanbadimage from "../images/dhanbadImage.jpeg";
import epitomecertificate from "../images/EpitomeCertifacte.jpeg";
import codehirex from "../images/codehirex.jpeg";
import srinjoy from "../images/srinjoy.jpeg";
import sayani from "../images/sayani.png";
import sumit from "../images/sumit.jpeg";
import sayan from "../images/sayan.png";
import soumyarup from "../images/soumyarup.png";
import joy from "../images/joy.jpeg";
import suman from "../images/suman.jpeg";
import codefy from "../images/projects/codefy.jpeg";
import carshowroom from "../images/projects/carshowroom.jpeg";
import codefushion from "../images/projects/codefushion.jpeg";
import havearelax from "../images/projects/havearelax.jpeg";
import rbac from "../images/projects/rbac.jpeg";
import medconnect from "../images/projects/medconnect.jpeg";
import threeinone from "../images/projects/3in1.jpeg";
import ecommerce from "../images/projects/ecommerce.jpeg";
import keeperapp from "../images/projects/keeper.jpeg";
import todolist from "../images/projects/todo.jpeg";


export const Bio = {
  name: "Srinjoy Das",
  roles: [
    "Software Developer",
    "Frontend Developer",
    "Full Stack Developer",
    "Programmer",
  ],
  Description1:"I'm Srinjoy Das, an SDE-1 at Automation Anywhere passionate about building scalable, high-performance web applications. I specialize in React, TypeScript, Spring Boot, and the MERN stack, with a strong focus on clean architecture, automation, and delivering impactful user experiences.",
  Description2:"🚀 Hiring? 💼 Have a project?",
 
  Contactinfo:
  "Email : srinjoydas.work@gmail.com",
  
  github: "https://github.com/srinjoy29",
  call:"https://topmate.io/srinjoy_das/1387297",
  resume:
    "https://drive.google.com/file/d/1AQ52bcDOFZhyTP1z3dGdrqVCwxoEw8W2/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/srinjoydas0212/",
  twitter: "https://twitter.com/SrinjoyDas47936",
  insta: "https://www.instagram.com/srinjoyhere/",
  facebook: "https://www.facebook.com/srinjoy.das.2002/",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "Next Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Material UI",
        image:
          "data:image/png;base64,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",
      },
     
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAY1BMVEWCgoL////l5eXk5OTm5ubu7u74+Pj19fXx8fH7+/vr6+t+fn52dnZ7e3t8fHzz8/OGhoaTk5Pa2tq3t7e7u7utra3Q0NCZmZnFxcWkpKSMjIzKysqpqanX19e/v7+dnZ1ra2tH/Sn9AAASPElEQVR4nOVdbZuyKhBWwTcErcxqa7fO//+VB9RKGF6tdvWc+bLPNY+m48DMzc0AURzHWYKTjP9FOEn5nzTBaKJNPLW5UYtxQozawqYtH1o8V4ui/4eFKEG9hcn4fgmaqU2S0ZaHNndpi0Fbjlr8Ni0atVGWZXmapjn/y/8U/E/B//6etnmnttFoI/4BemcgxUVBWuLS8iaES/6XENLwPw1vSpPPngzXPj67TYtDtIhrI6ztZm/pkuKZDbcpLgt0uV73+7b74tJ1bdterztUZDgl5Se6JJpoP+ZD/uNNnKNTdztHlFJWV7LUjCuj8609oIx/hfRzPvxI3yqanBzaIzeNGxbZpKq4pdG2PeBcdKKXepyhH747lgotut4iyuymKYYyGt1O6aRpvi+WvrXzYZKSXbehDscZrKxp1F1wms7sfNZ8iAa/oLGbIeSjJRrt9RjmO+hLtj31HkDD+6GhS6Kxm3losaKNAs0yG9uQ042+Yt1dano8lS+ahT6QLUjH2BvMG42sOxKTt2WLV8MLwqT42b7FfU+p6PYkUunrQSd6PUU0pK3e576nsKgl8euJQ84W4ck/IWj/UmyxScW+EQlO/gi9M1vkqPuYfYONXfGWbDHbh+1H7Rts3AdCNUX7Qj/M8lNUf9g+IXV0KssX+uH8WIo2n4gvOmFnFAjVprF0bj7Mvukv2SeEfudkbj6cBdUScnhz/nMJ745kHoCbh0uz2286cBB2K3NvqDbFpeHZAse/7cBBKnpKfZvmS1wbSY6/78BB2FGid/wAXPAYvznMGvy9R6rqEH+Ya0ua6185cBDaEm1eQO/i2vDxt3KgSdgRuUmA2Vwb2W3+roXepdqgIAAX0g/zw187cBB2yD/DtaXt33bBp/DO6IBqs0ZP6dcyPCiEfZXeAM4b0xTH3xhH+Aq72aHaFNP4RRqcnP8+xkylOqO3ZguMFhBEZRlCqgmqhXJtJdr8tUE6yd/GtZVkaQ4cJS0n75tqE0fqw7VhtFADo2j3Fq4NL7OJ9rJ5C9eWLNdAHlHdAM7ZD/OFpQlZqm2hQrU8kGtLj0s2kJt4dAE4Rz5Mv5aEZHRS6wCcP9eWt8vBoiahJzuAs0YacljKaMIm9IKtkcaWLXbL96AQtsMWAGcZHyZ4wXlCkk0410Z6Vm3hYfQp1TZWoJoX19Zc19FGhbCOhI+e8M8aosxd6CGYa8PJX790mFTBXFu8mk44SHUsIdeW27i2VWTCqdALCeHakmxtBnITrflQ5drIbV1ttJctCeDaVtdGhdCDPtLossUK26gQmjW+XNv3Ctsol+o7s3NtZEwcGVqnC7kTf0YriJ1ry9cCuKGc/bi203rwqCrs4sW1/fVrviKVB9fWtEtnZmxSt42La0vQetuoELZzcW2kW2emuEvVObm2dbtQpH0719bs1+1CkfaJbWyBydpdyIONNVuQdu0u5E5sCeTaSErEGJ+kxfoN5CYWI9c2ADh59PQT3EjF4roqOh+3x/OG/5u5y/oAJvT9qup1GwO6ZD+xmWvbej5sfCSj5/ZARAMfJCM/+1tlLz5lRawI8QP61Zd649Fw5TZOTFyb57PGV2VfP6X6UCGojay/A27wI2Yr9TbjrBFFyXQEnOcj15ZnTUC2p+eDzrpRdluzjdAX8dbjuTRRbjLzuVVX5gPXlitcm3+qoEdksa935Nn4Y/SiXty42w5rlXtyy8uy2JAPfYdNbLNz2CfkZHxtmqrXXpxPPqu32PzODgau7eZnIL162Ce+4tk0StmAa13tlKrxyTp1W91kru1BknrFmaqv8PCTzvCL9bd6pYP7omqn3zmuR4lubHH1iTMUxgmLXAwvAt7YEjciTXDKHK262uPHngVPH6am9CK92j7EQPO3Zo16pY2DBoni7HrPSYUGH+OTYYzvkwxhGJxrIogcpZlaoGrgdtdPUJJDrs1j0h42LrcYmh+I/uauBS51dML+nl0Os4U73fd1HUDK5HDat/vrAWW6/zZlDQoyjomHVt1ty4R3qbocjp6cLCnr4Ovj9nzf1YND8HOrAg8hX/o3ZwDy6R8LEoUPAoo2mcy1cZDjJLqrLXj3n7OCsistmNN/O/h72lcAXd+viIlibpTEtRVO+oKpjRCddW+kATzY0BUBcuhgtBHJWxKPTtj/uPgwUj5sDG3pIaDfGFdfwJRpYA5AjNRkgUppy65M+LhPgAqJa8t97phIaUbWfKiqAk/TtaqFIGOBj+DVCe+/PeXasCsbKnGhtI/M1RczLCcCTTDeyxeCRLH3H/7s5P3asGNJk9pnXNQDxfL1hkANEYTcTtVE4dkJhdQnOVs4SbbQtkJlWGYigKgK49OpDWqi8O2EQqqWTLk20thBKZNzgE/AVj6/6TIwkJoMUoGH/Tshl2Mjc232q2Xo6zXMUrrQyQA71Qg2YcNALw0s55W5Nvv4rJZ7oRPZ9yI3sdKYW1SIkN+vVEFPQCfsfziXuDY7oqH59EmepSiKC4zVDwCVjYNKNR6XgVwuv//OteV52pgake5d/VyoRhHz0AUMpPqSOpAoQgvt6lPT2zbEUvusIZPgjHdjUbqY0UKA6HtvqXYH19RX3VAbPeRDYiWhqPQoF7ybvLrnffRHsYb3AzWNzKiAuZGnhYjYWp7Ckvh/Sya9uYUxrKV+Lr6GmihCO6GQ82jhEEttV9bSwDcgolVS80vNN4KBVKkmiqBMeJfp2MIYy4XIDSZkklhOo5YLmYPg8oej0x8tJ1xbYbNQ7k4hdZkydLPdCQdSU5lXhkaLwYeEkKK0/sRRelpISZgchK3eB4ThRLJ5FT4MpYSk5RBLbfMGlZyYgibgpHhhnX6t5O8oycyS8/7pYyzFV8tXklF3wzb+EkndyxJqxGO0RJ6Ques+6v3UQttEjmsizVcsnK8QMJAaZXYtaHWNH1xbaesicC5srji6MJyR6r/L7OKJ6ppz2/IhllotfJeBrioBzeRwPLsTit/bk2c+tI3w32ehk87TcK0vLL7iFj65Nhvwrt9mobMcSdMVZ9snIBV5cG3E9nX13WOOOOGQpp3aA7D718ZY+ksWWgeh/TvpbpptYj+svVtoA1RggDpbXPUIeug2O9TcLRR8VGHz4fv6ocNCOKXYiyONWiz8ikWx3sDT2CIN0z53loX2dzU1lrkp/x5p+mxhs1DOFqL8dqZgeywFjNRDunkZo+rSJ9dmzYfSAJz8Q2eL3UDLDLov96VYyDP+nWtrbBYyaQrihehtfx0wSfPyQ6s2e3Bt1vYjD/I+ZqHFQHNdjv0nReTyGVvINI2V75gvgP5VTJyz4vM+thgstI2AZTrzIxaqiaJQYcacEUY9+rCPpdZamvkshreoiWILaq9mpAy2688eGCy03i8nRJ/asFBRh6AnBkF4+D4yFBFPrk1OVB9YNaTSv31BLcj/wSmDNhOuzTq55k1dzxSQKHpbAIXqUUgsC82eXBvC1jeQwkBQtbuXqIliDHugnQanjOnMTGptAnKDmWuISdRCnUfGBe00MGWcpZkZ+9yTVA0V0hHZVAyXqCOKs/F/Aj/ubfRhURRNXlpBsdwRDTVc2hsvu4noiSjVU5MpCrVkJSxlVG3JbbtzbaaSnvFamVzwX1gj5xntJWqikLu56sSQGRp2kOra7F9HflP/SWDpy2hDFFMLSqSAUIN6z4BlS2Ief1LXZq/FkJup92PkGKJjaUCiUJwEeI2AlMGjx7OuLcHEfrUM3HzHFzK41IEhlSGBfVx1YsCeJESU85bJ3UI7GFN6ix//JY9pdRVboKITJK0KtFPvMoIjCalrUx/ks5uiMl+mwUKgm2mwJ+TfPA2c1rWVOQc3jtpEqtQS+MyrO9wDE4U+D6kW+i3t4TFMrCEts0ddmyPLgfIz5wkClVw0rQnAYFJLOzCD8dQvZYgZdmkNqatGGGRf05qm0b6NUhUO469viTpsp36xPFbWkDYu0AdQ4o/lMCtQ6g1dCBKFOSWrT8492ulQ5/3g2ji4yVyTCrCyPm4N/CCLADMIG6Baom4mD2A79UgZ9bXhiE3Y9lhR4kxymqmvvGPAkRWN4Iw83C8Flv5b1j2B9Q3ulEF3GKwKchMwunXNh+/oeRJuzejmW7O+FDZA4BcrbAT+dqeMTQbXkDpHRZpFM4Mnd5e9OMq42192aoFaLw0MIaBX258M5hVdA5yqfZwNxWMp7tcfYjc9UQetrnwKbB2gxTs+L2ynjtlvdhlOXcaTNaQYu9MMm2Ui3BAcLIJzDvzgMjA75mDJzDWkzDa7oJccLs2AcxTOB8Nb7CsTpmtIB66tLEjqnITmUp/1iwyNomsZteoQD2IEVNlaU0Z9SnNu1IRrG3Yc8Bsx+KzFf4huFAJ+wWtIDdvptyW/GHYc8FuPT8EKCaPkuhPaYAL3eqxm+s2Y3/r1+LodeDz3VKgA9WCQkxbzgEThSd7BdmpMGYKTePqw59rynGOcwrsmgG08ljxfIu0HA4nCm/aB7dSUMmg+GDXl2ob92vypUFZdtcn9LunecAgySBT+82bem6KIzbAM+7WFMPbifHBDvSQ+Gc+whoWyATuJwnaqJ9Aowsb92sL2GKppddwfyMSZOTmITYYsrV19x6DFTGApcqzdXm4bg/3a7uePkfBtL8UidVZtztvteRP1/7b65HzcyhL2tI1y91aHUtipX7rN/RhPuLZxvzYHqbgS+d/t11aWgmsjOf/L/6Tr33OPCahWlg23JisnXNu42/VaN0l+ipjPtZ6N8B/Z+9JyNgJZuRN7jk3esXzk2sY/Ta6hHNYkrCgGa5pC5dri+9kItvUzi5f66nM2wpqbaeV1NsLa9/NWz0Z4cG09yBFbZJTzClaXIBsyQjWMn7EUno1gX424ZKE/WDkbQbPbNcK8wfov116UiLMR7hYihWsry4L/fQA4n920Figsf0C1Jwwt5WwxJn+yosOsnsLGrQS9ziFNV3nOTBpyDumHyrk/KfTR+RQfTri2CYDLV5cU2amUrNBzbRN3ktWd2dXEmlPJrOeQ/vU7B0oSfA4pXtWZT/ez80znkHJbe65NAnAzquP/TEQZhQTVjFybfJjHarpiP/8uQTWQLTDSWJgs+bxqSTYAqk0tlLk2CcClazlLFqUqVDNzbUryX0W0EdMZKlTzOYc0WdWZzrZTq60+TMnX0k1kw7ncifkcUhnkKACuycuFY/DqFuugmpVrUwEcLIdZkFRnPVTzPZd7mHNbcs7YTDpfEnIOqQzg/toMi5igmoVrGwGcpHXVD/+dZCXWQjVs59pgg13qIUm5Eaq5uDbVwnKJDbXiBhqhmotrgwAOb5bmxuqMSzNUc3FtcvIf4s/CkoZIExaoFpYtBm0xa3PGT0l9hHnBmi2sPrwDuNtyABy7OaCamWtrLAAu3i9lpEH3LqjmwbWNWtmd12WYKBbFOaCaF9em0ZKfJfTFeufufD5cm1aLkfGUqt8Sdu7fzAHVDFybB4CLy++/bam0Hd5MhmpYhWoTrSVbID0D9/5tIwKk3yzHA6r5cW0GLbEci/dhYVuEVVCmh2qeXJsEiCba8o/SBt0X/Ttk2jcL5dqQTUt2f+BGdu6PzEy8oJo316YHcFxL9HX4n5OKtinW5AWPbGHn2sza/PabTZXeUqIHZU5tZIRqDm2TGZYbfEBYdMkAiNRDS6jVcW2q4wzaIr5algK/Typ2JcQIyt7BtVm0PP9/2saKdplf53uBazNoxe/ku9tHbazokUwDqATK9FoL1yaSKYRqd21u0hZfH7OR+6+IG/AOE1DmAeAgE2UBcIlWS1BHPxFzatohXQbwgWqhXJtdy7Njetm82ZEV3Vwx8QBl7+LaTADufm0c777e6EhGv3ZxagNlZqimal+MNA9tgsv4YFzQFSQ8uhxSgsNjiiHSvJQtplrx62i/pS/lyKqm22s2Ly+8zLX5aHmXJGKXhXqOlVXFou6EyDCE9wVl7+HaQrR5nmXodItYkJUVo9HtuhNbbweCMqfWiLyDAJxGuzt9b/stM5ztkhu37U48WDV4Bih7L9cW0iV5b2jiHJ262zmilD12B6meu4RQGp2P3QWJ0Jc+u87zF5LZnW821+YVViVtI5Ja2aDLdb/ft93X7fbVdW3b7q871GT8P6VRrQcoCw6req5tJoC7ayGk6ktXSJ/BY5KSHgoRy7VWUBYG4KxMVBCAy21aArVyI9RrZ0O1l7g2K4BLVG0+aIlR+yoo+wjX9prWC369rn0AuE9HmlTu+3rtRyPNv+c/cIe0nzmlAAAAAElFTkSuQmCC",
      },
      // {
      //   name: "Graph Ql",
      //   image: "https://www.vectorlogo.zone/logos/graphql/graphql-icon.svg",
      // },
    
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Postgresql",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
    ],
  },
  {
    title: "Coding Languages",
    skills: [
      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
      {
        name: "C",
        image:
          "	https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT5sRMv8ANREvbK2PrqfO7ptvi_W62kgn1eeUIEPoZXLriFkXj2zInAvUWh6Wcz_4-Dcl4&usqp=CAU",
      },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "Solidity",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/solidity/solidity-original.svg",
    }
    
     
    ],
  },
  {
    title: "Others",
    skills: [
      
      {
        name: "Git",
        image:
          "https://git-scm.com/images/logo@2x.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "	https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSgPT5cgE3Wofm3b-FoCwySaAZ6iL3uYkeuOrB-WKJSTg&s",
      },
      // {
      //   name: "Adobe XD",
      //   image:
      //     "https://camo.githubusercontent.com/c205ecbe12500177d102169d97bc1c17c545155fdf5ec78c08d54ac53e5b38c1/68747470733a2f2f63646e2e776f726c64766563746f726c6f676f2e636f6d2f6c6f676f732f61646f62652d78642e737667",
      // },
      {
        name: "Figma",
        image:
          "	https://upload.wikimedia.org/wikipedia/commons/thumb/3/33/Figma-logo.svg/1200px-Figma-logo.svg.png",
      },
    ],
  },
];

export const experiences = [
  {
    id: 1,
    img: automationAnywhereLogo,
    role: "SDE-1 (Associate Software Engineer)",
    company: "Automation Anywhere",
    date: "Oct 2025 - Present",
    description1:
      "📍Implemented OS-based filtering on the automation listing page, significantly improving result relevance and user experience across environments.",
    description2:
      "📍Developed a Markdown + Mermaid rendering component for a conversational AI assistant, enabling rich charts and diagram visualizations within chat interfaces.",
    description3:
      "📍Enhanced the Case View UI to display nested (child) process execution details, providing real-time visibility into complex workflow states.",
    description4:
      "📍Authored 100+ UI automation test cases using Cypress and Playwright, improving regression coverage and reducing manual testing effort.",
    description5:
      "📍Actively contribute to the HBC frontend platform by developing production-ready features using React, TypeScript, and Spring Boot.",
    skills: [
      "ReactJS",
      "TypeScript",
      "JavaScript",
      "Redux",
      "Spring Boot",
      "Playwright",
      "Cypress",
      "Git",
    ],
  },

  {
    id: 2,
    img: automationAnywhereLogo,
    role: "Software Engineer Intern",
    company: "Automation Anywhere",
    date: "May 2025 - Sep 2025",
    description1:
      "📍Worked on the UI Proof of Concept (POC) for Process Composer V2, improving the user experience for parallel process design.",
    description2:
      "📍Implemented the React Flow canvas renderer, enabling an intuitive workflow visualization experience.",
    description3:
      "📍Resolved UI bugs and developed automation test cases using Cypress and Playwright to improve application quality.",
    description4:
      "📍Automated 50+ UI test cases with Cypress, increasing regression coverage and reducing manual testing effort.",
    skills: [
      "ReactJS",
      "TypeScript",
      "JavaScript",
      "Redux",
      "React Flow",
      "Playwright",
      "Cypress",
    ],
  },

  {
    id: 3,
    img: capsitechLogo,
    role: "Software Engineer Intern",
    company: "Capsitech",
    date: "Jan 2025 - Apr 2025",
    description1:
      "📍Developed full-stack features across 3+ client projects using React.js, Node.js, and Express.js.",
    description2:
      "📍Built complex form-based UIs with Fluent UI and Formik, improving user experience and reducing input errors.",
    description3:
      "📍Optimized MongoDB and SQL queries, improving data retrieval performance for internal applications.",
    skills: [
      "ReactJS",
      "NodeJS",
      "ExpressJS",
      "MongoDB",
      "SQL",
      "Fluent UI",
      "Formik",
    ],
  },

  {
    id: 4,
    img: unblueLogo,
    role: "SDE Intern (Frontend)",
    company: "UNBLUE CONSULTATIONS",
    date: "Dec 2023 - Mar 2024",
    description1:
      "📍Built an adaptive fundraising website using React with a component-driven architecture.",
    description2:
      "📍Designed and developed the Services, Metrics, and Team sections, contributing to improved user engagement.",
    description3:
      "📍Implemented React Router and optimized component rendering, reducing redundant renders and improving application performance.",
    skills: [
      "ReactJS",
      "JavaScript",
      "HTML",
      "CSS",
      "Tailwind CSS",
      "React Router",
    ],
  },
  // {
  //   id: 4,
  //   img: "https://firebasestorage.googleapis.com/v0/b/portfolio-3dfd0.appspot.com/o/images.png?alt=media&token=840792ab-a64c-45db-abae-cb8dc39970d6",
  //   role: "Web Master IEEE HIT SB",
  //   company: "IEEE HIT SB",
  //   date: "JAN 22 - JUNE 2025",
  //   description1: "I joined IEEE HIT SB as a video editor in 2022, volunteered from 2022-2024(May), and currently, I am selected as a web Master.Conducted workshops and competitions, impacting 500+ students.",
  //   skills: [
  //     "ReactJS",
  //     "Tailwind CSS",
  //     "MongoDB",
  //     "NodeJS",
  //     "ExpressJS",
  //   ],
  // },

  // {
  //   id: 5,
  //   img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/gdsc.jpeg?alt=media&token=c162329c-efaa-4be8-a173-8d3f4c48ea70",
  //   role: "WEB Developer",
  //   company: "GDSC HIT",
  //   date: "SEP 2023 - Present",
  //   description1: "As an WEB developer at the Google Developers Student Club (GDCS), I have had the opportunity to work on exciting projects and collaborate with talented developers who share my passion for technology. Through my involvement with GDCS, I have also had the opportunity to host  numerous events, workshops.",
  //   skills: [
  //     "Leadership",
  //     "Web Application Development",
  //     "ReactJs",
  //     "HTML",
  //     "CSS",
  //     "Javascript",
  //     "Figma",
  //   ],
  // },
  
];

export const achievements = [
  {
    "id": 0,
    "img": epitomecertificate,
    "role": "Epitome 2025 2nd Runner Up",
    "company": "GRIET Hyderabad",
    "date": "Feb 2025",
    "desc": "We secured 2nd Runner-Up at GRIET Hyderabad Hackathon – EPITOME 2025! 🚀 Our Smart Hiring & Learning Hub helps tech talent apply for jobs, practice DSA, join live interviews, optimize/review code with AI, convert handwritten code, build ATS-friendly resumes, and code in an IDE. Recruiters can post jobs, shortlist candidates, conduct live interviews with coding/video, and use QGenAI for AI-driven question generation.",
    "link": "https://drive.google.com/file/d/11GvhWY4vnctkz5Zgg_ae2VDAhNAjj8eJ/view?usp=sharing",
  },
  
  {
    "id": 0,
    "img": dhanbadimage,
    "role": "HackFest'24 Finalist",
    "company": "IIT Dhanbad",
    "date": "May 2024",
    "desc": "Excited to share that our team, Access Denied, was among the 70 shortlisted from 270+ teams in IIT Dhanbad’s 36-hour nationwide hackathon! Advancing to the final round on May 10-12, we secured a finalist position. Project: CodeFusion\nA unified platform integrating Code Collaboration, IDE, Code Converter & Optimizer, and Review tools—enhancing developer productivity and streamlining workflows.",
    "link": "https://certopus.com/c/407c07c033a64da3807287b365100609",
  },
  
];

export const education = [
  {
    id: 0,
    // img: "https://firebasestorage.googleapis.com/v0/b/portfolio-3dfd0.appspot.com/o/clg.png?alt=media&token=d7985c2f-9f38-4b86-80c0-f8ac7586bbac",
    school: "Haldia Institute of Technology , Haldia",
    date: "Oct 2021 - JuLY 2025",
    grade: "8.94 CGPA",
    desc: "I graduated with a Bachelor's degree in Computer Science and Engineering from Haldia Institute of Technology with a final CGPA of 8.94. Throughout my academic journey, I built a strong foundation in Data Structures & Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks. I actively contributed to the Google Developer Student Club (GDSC) and served as the Webmaster of the IEEE Student Branch, where I managed the organization's web presence and collaborated on technical initiatives while strengthening my software development and leadership skills.",
    degree: "Bachelor of Technology - BTech, Computer Science and Engineering",
  },
  {
    id: 1,
    // img: "https://firebasestorage.googleapis.com/v0/b/portfolio-3dfd0.appspot.com/o/PORABAZAR.jpg?alt=media&token=b4468038-b3c8-4d2b-8b29-ba2c7701e2eb",
    school: "Porabazar Ramdulali Mukherjee Vidyalaya , Hooghly",
    date: "Apr 2018 - June 2020",
    grade: "87.4%",
    desc: "I completed my class 12 high school education at Porabazar Ramdulali Mukherjee Vidyalaya , Hooghly, where I studied Science (PCMB).",
    degree: "West Bengal Council of Higher Secondary Education, PCMB",
  },
  {
    id: 3,
    // img: "",
    school: "Somaspur K K High School, Hooghly",
    date: "Jan 2012 - Apr 2018",
    grade: "93.1%(Class 10th Board Examination)",
    desc: "I completed my class 5-10 education at Somaspur K K High School, Hooghly.",
    degree: "West Bengal Board of Secondary Education",
  },
];

export const projects = [
  {
    id: 21,
    title: "CODE HIRE X",
    date: "Feb 2025",
    description1:"🏆 2nd Runner-Up at GRIET Hyderabad Hackathon – EPITOME 2025! 🎉",
    description2:"👨‍💻 For Users (Tech Talent): Apply for jobs, practice DSA with streak tracking, join live interviews, use AI tools (Code Optimizer & Review), convert handwritten code with DigiScribe, generate ATS-friendly resumes, and code in an integrated IDE.",
    description3:"🏢 For Recruiters: Post jobs, shortlist candidates, conduct live interviews with real-time coding & video streaming, and use QGenAI for AI-driven resume-based question generation. ",

    image: codehirex,
    tags: ["React Js", "Tailwind css", "WebRTC", "MongoDB", "ExpressJS","NextJS","Socket.IO","OPEN AI API","Python","Flask"],
    category: "web app",
    github: "https://github.com/Epitome25/Codex",
    webapp: "https://codehirex.vercel.app/",
    member: [
      {
        name: "Srinjoy Das",
        img: srinjoy,
        linkedin: "https://www.linkedin.com/in/srinjoy-das-589a95206/",
        github: "https://github.com/srinjoy29/",
      },
      {
        name: "Sayani Jana",
        img: sayani,
        linkedin: "https://www.linkedin.com/in/sayani-jana-895899260/",
        github: "https://github.com/Sayanijana23",
      },
      {
        name: "Sayan Maity",
        img: sayan,
        linkedin: "https://www.linkedin.com/in/sayan-maity-718974253/",
        github: "https://github.com/Sayanmaity2003",
      },
      {
        name: "Soumyarup Das",
        img: soumyarup,
        linkedin: "https://www.linkedin.com/in/soumyarup-das-58761425a/",
        github: "https://github.com/soumya-rup",
      },
    ],
    
  },
  // {
  //   id: 20,
  //   title: "Ecommerce",
  //   date: "Jan 2025",
  //   description1:"Product Listing & Search – The platform displays a list of products with images, prices, ratings, and discounts. Users can also search for specific products using the search bar.",
  //   description2:"User Authentication & Dashboard – There is a user profile section and a dashboard, suggesting features like user authentication, order tracking, and personalized experiences.",
  //   description3:"Filtering & Sorting – The interface includes filtering options for categories and brands, along with sorting functionalities to refine product selection.",
  //   image:
  //     "https://firebasestorage.googleapis.com/v0/b/portfolio-3dfd0.appspot.com/o/ecom.jpg?alt=media&token=9a013274-788f-4d08-88e2-e04223311d23",
  //   tags: ["React Js","Redux","JWT", "Node JS", "ExpressJS", "Mongodb","Tailwind Css"],
  //   category: "web app",
  //   github: "https://github.com/srinjoy29/E-commerce",
  //   webapp: "https://e-commerce-liart-delta-57.vercel.app/"
  // },
  
  {
    id: 19,
    title: "codify",
    date: "Dec 2024",
    description1:"The image showcases a web interface for a platform called Codefy, designed for coding, testing, and running code. The layout is divided into two main sections: the left panel highlights the platform branding, and the right panel manages the user’s coding workspace.",
    description2:"On the left, the Codefy branding features its logo, tagline (“Code. Test. Run.”), and a prominent button labeled “+ Create Code Lab” to initiate a new coding environment. The vibrant design, with a coding-themed background, enhances the aesthetic and conveys the platform's purpose.",
    description3:"On the right, the My Code Lab section displays a structured workspace. A folder named DSA is shown, with two code lab cards underneath. Each card includes details like the programming language (e.g., C++ and JavaScript), creation date, and icons for editing or deleting the code lab. Options for “+ Create New Folder” and “+ New Code Lab” provide functionality for organizing and adding new projects, creating an intuitive and efficient user experience.",
    image:codefy,
    tags: ["React Js", "Node JS", "ExpressJS", "codemirror","Judge0Api","RapidApi","LocalStorage"],
    category: "web app",
    github: "https://github.com/srinjoy29/CODEEDITOR",
    webapp: "https://codefy-eight.vercel.app/"
  },
  {
    id: 18,
    title: "CarShowroom",
    date: "Dec 2024",
    description1:"The image depicts Own-CarShowroom, a platform designed for users to manage their car collections seamlessly. The header welcomes users with a brief introduction about the platform's functionality, such as tracking vehicles, adding new cars, and managing essential details like name, model, and price. The cheerful pink theme, paired with a red car graphic, adds a friendly touch to the interface.",
    description2:"A search bar is prominently displayed, allowing users to filter their car collection by attributes like name, model, or price. Next to it, the Add New Car button enables users to expand their collection quickly and conveniently. The layout emphasizes usability and quick access to core features.",
    description3:" Below the search bar, the platform displays individual car cards showcasing details such as the car's name, model, and a brief description. Sleek car images enhance the visual appeal, making the browsing experience more engaging and intuitive for users.",
    image: carshowroom,
    tags: ["React Js", "Node JS", "ExpressJS", "Mongodb"],
    category: "web app",
    github: "https://github.com/srinjoy29/CarShowroom",
    webapp: "https://car-showroom-w9uw.vercel.app/"
  },
  
 
  {
    id: 17,
    title: "Code Fusion",
    date: "May 2024",
    description1:
      "Our team was selected from 260 teams for CodeFusion, a collaborative code platform. CodeFusion features a secure Socket.IO chat room for real-time collaboration and interaction with an AI chatbot. It supports over 40 programming languages and tracks time consumed on tasks. The platform offers code review for assessing time and space complexity, efficiency, and optimization. Additionally, it includes a code converter that translates natural language to code and converts code between different programming languages, providing explanations for the changes. ",

    image:codefushion,
    tags: ["React Js", "Tailwind css", "Firebase", "MongoDB", "ExpressJS","NextJS","Socket.IO"],
    category: "web app",
    github: "#",
    webapp: "https://fusioncode-24.netlify.app/",
    member: [
      {
        name: "Srinjoy Das",
        img: srinjoy,
        linkedin: "https://www.linkedin.com/in/srinjoy-das-589a95206/",
        github: "https://github.com/rishavchanda/",
      },
      {
        name: "Sayani Jana",
        img: sayani,
        linkedin: "https://www.linkedin.com/in/sayani-jana-895899260/",
        github: "https://github.com/Sayanijana23",
      },
      {
        name: "Suman Dhar",
        img: suman,
        linkedin: "https://www.linkedin.com/in/suman-dhar-2972242a3/",
        github: "https://github.com/SummanDhar",
      },
      {
        name: "Sumit Kundu",
        img: sumit,
        linkedin: "https://www.linkedin.com/in/sumit-kundu-10b01d02/",
        github: "https://github.com/SumitKundu102022",
      },
      {
        name: "Subhrajyoti Maity",
        img: joy,
        linkedin: "https://www.linkedin.com/in/subhrajyoti-maity-114989281/",
        github: "https://github.com/Subhrajyoti22",
      },
    ],
    
  },
  {
    id: 9,
    title: "HAVE-A-RELAX",
    date: "MAR 2024 - APR 2024",
    description1:
      "Developed this Full Stack website during IIITDM JABALPUR hackathon, this project revolves around a dynamic yoga class booking platform where users can securely book classes through payment gateways.Implemented three distinct login dashboards for Admin, User, and Instructor,each with tailored access privileges.Integrated Firebase Google authentication for seamless sign-up and login experiences, along with Stripe for secure payment transactions.",
    image: havearelax,
    tags: [
      "ReactJS",
      "NODE JS",
      "EXPRESS JS",
      "MONGODB",
      "HTML",
      "CSS",
      
    ],
    category: "web app",
    github: "https://github.com/srinjoy29/Albatrosses-HAVE-A-RELAX",
    webapp: "https://final-have-a-relax.vercel.app/",
    member: [
      {
        name: "Srinjoy Das",
        img: srinjoy,
        linkedin: "https://www.linkedin.com/in/srinjoy-das-589a95206/",
        github: "https://github.com/rishavchanda/",
      },
      {
        name: "Sayani Jana",
        img: sayani,
        linkedin: "https://www.linkedin.com/in/sayani-jana-895899260/",
        github: "https://github.com/Sayanijana23",
      },
      {
        name: "Suman Dhar",
        img: suman,
        linkedin: "https://www.linkedin.com/in/suman-dhar-2972242a3/",
        github: "https://github.com/SummanDhar",
      },
    ],
  },
  {
    id: 18,
    title: "RBAC",
    date: "Nov 2024",
    description1:"The image shows an RBAC (Role-Based Access Control) System dashboard for managing users, roles, and permissions. The sidebar includes a welcome message for the admin user and a logout button, while the header displays the app title and navigation tabs for Users, Roles, and Permissions, with the Users tab currently active.",
    description2:"The main content area features a search bar and an Add User button, followed by a table listing user details like name, email, role (admin, editor, viewer), and status (active or inactive). Status is color-coded for clarity (green for active, red for inactive), and action buttons allow the admin to edit or delete users.",
    image: rbac,
    tags: ["React Js", "Node JS", "ExpressJS", "MongoDB"],
    category: "web app",
    github: "https://github.com/srinjoy29/RBAC-Application.git",
    webapp: "https://rbac-srinjoy.netlify.app/"
  },
  {
    id: 16,
    title: "MedConnect",
    date: "July 2024",
    description1:
      "• Developed a full-stack (MERN stack) project named MedConnect, connecting doctors and patients through an organizational website. Users can sign up, view available doctors, and book appointments. Doctors can join as users, apply to become verified doctors, and get approved by an admin after verification. The platform includes an admin dashboard where admins can manage users, doctors, appointments, and applications, along with notifications for any events. New features include a crypto secure vault where patients can store their prescriptions securely on the blockchain with secure MetaMask payments.",
    image: medconnect,
    tags: ["React Js", "Tailwind CSS", "MongoDB", "ExpressJS", "Node JS","Solidity", "Web3"],
    category: "Web3",
    github: "https://github.com/srinjoy29/MedConnect-Frontend",
    webapp: "https://med-connect-frontend-tawny.vercel.app/"
},
  {
    id: 3,
    title: "Three IN One",
    date: "June 2023 - July 2023",
    description1:
      "3-IN-ONE is a multifunctional web app, combining speech-to-text conversion, voice commands execution, and note-keeping. Easily convert speech to text, execute commands, and store notes with a user-friendly interface.",
    image: threeinone,
    tags: ["React Js","HTML", "CSS"],
    category: "web app",
    github: "https://github.com/",
    webapp: "https://threeinonesrinjoy.netlify.app/",
  },
  {
    id: 10,
    title: "Ecommeerce Website",
    date: "Jan 2023 - Jan 2023",
    description1:
      "Its is a single page Website design for a Clothing Store. This is created with HTML,CSS,JS.",
    image: ecommerce,
    tags: ["HTML", "CSS", "JS"],
    category: "web app",
    github: "https://github.com/srinjoy29/womenfashionvilla.github.io",
    webapp: "https://srinjoy29.github.io/womenfashionvilla.github.io/",
  },
  {
    id: 4,
    title: "Keeper App",
    date: "Dec 2022",
    description1:
      "Its all about a Basic Keeper App project , in it user can keep there important note by title and details.",
    image: keeperapp,
    tags: ["React Js", "HTML", "CSS"],
    category: "web app",
    github: "#",
    webapp: "https://noteskeeperwebsite.netlify.app/",
  },
  {
    id: 5,
    title: "Todo Web App",
    date: "Apr 2024",
    description1:
      " A Todo Web App made with React JS, Redux, and Material UI. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the tasks and can create a new task. It has a calendar where users can see all the tasks on a particular date. It has a search bar where users can search for a particular task.",
    image: todolist,
    tags: ["React Js", "Local Storage", "CSS"],
    category: "web app",
    github: "https://github.com/srinjoy29/TODOLIST-INTERN",
    webapp: "https://todolist-sd.netlify.app/",
  }

];

export const products =[
  // {
  //   id:1,
  //   name: "Top HTML Interview Questions",
  //   price: "0",
  //   description1: "This is an amazing product that helps you with various tasks efficiently. It is built with high-quality materials and provides excellent performance.",
  //   tags: ["HTML", "Interview Questions", "Top-Questions"],
  //   image: "https://nestify.io/wp-content/uploads/2024/01/What-is-HTML.jpg",  // Replace with actual image URL
  //   buyLink: "https://docs.google.com/document/d/e/2PACX-1vSXtaEVhFO3n3fNXjbHuLTNhMiLFec5Auxzq0dq-p_HuGLGQIyCecDjcHBzbU79Ph8jltC5nSNp1jk0/pub",
  //   category:"development",
  //   detailsLink: "https://docs.google.com/document/d/e/2PACX-1vSXtaEVhFO3n3fNXjbHuLTNhMiLFec5Auxzq0dq-p_HuGLGQIyCecDjcHBzbU79Ph8jltC5nSNp1jk0/pub"
  // },
  {
    name: "Top 20 React.Js Interview Questions",
    price: "5",
    
    description1:"Top 20 Questions - Download Now Free 👉 Details Link ",
    description2:"Top 50 Questions - Download Now Just at 2Rs 👉 Buy Link",
    
    tags: ["React Js", "Interview Questions", "Top-Questions"],
    image: "https://i.ytimg.com/vi/WvtGAoI95bQ/maxresdefault.jpg",
    buyLink: "https://topmate.io/srinjoy_das/1386493",
    category: "development",
    detailsLink: "https://drive.google.com/uc?export=download&id=181octQNYuO0GK5AFsFRj0SFVg-IGbzCy"
    },
  {
    name: "Top Oops Interview Questions",
    price: "0",
    description1: "Master the core concepts of Object-Oriented Programming with these top OOP interview questions. Covering key topics like inheritance, polymorphism, encapsulation, and abstraction. Perfect for demonstrating your understanding of OOP principles. Ideal for excelling in technical interviews and securing your dream job.",
    tags: ["Object-Oriented-Programming-Language", "Interview Questions", "Top-Questions"],
    image: "https://miro.medium.com/v2/resize:fit:600/0*7zMicw-FfThCbN35.png",  // Replace with actual image URL
    buyLink: "https://docs.google.com/document/d/e/2PACX-1vRPsMWvG9q_UN3GNyL0dvwsdOSt9w66cFWjfamaMgyXLKYz5boSgg3kUvLAcl_tuaGb8keEchj5l_Ga/pub",
    detailsLink: "https://docs.google.com/document/d/e/2PACX-1vRPsMWvG9q_UN3GNyL0dvwsdOSt9w66cFWjfamaMgyXLKYz5boSgg3kUvLAcl_tuaGb8keEchj5l_Ga/pub"
  },
  {
    name: "Top HR Interview Questions",
    price: "0",
    description1: "Prepare for your HR interview with these top questions, covering key topics like teamwork, leadership, problem-solving, and career goals. Perfect for showcasing your communication and interpersonal skills. Gain confidence in handling behavioral and situational questions. Ideal for acing HR rounds and securing your desired role.",
    tags: ["HTML", "Interview Questions", "Top-Questions"],
    image: "https://bugspotter.in/wp-content/uploads/2024/11/Purple-Colorful-Modern-Clean-Project-Management-Flowchart-Brainstorm-1140x570.webp",  // Replace with actual image URL
    buyLink: "https://docs.google.com/document/d/e/2PACX-1vRoa6S4zTsiLDrcCW7TX51vIL6eAmgaX2wZ0KtK3-e7bC4MsYugYvuY31WKfrn-bZ-HRGvXO0vtBFc8/pub",
    category:"development",
    detailsLink: "https://docs.google.com/document/d/e/2PACX-1vRoa6S4zTsiLDrcCW7TX51vIL6eAmgaX2wZ0KtK3-e7bC4MsYugYvuY31WKfrn-bZ-HRGvXO0vtBFc8/pub"
  },
 
  
];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];
